<template>
  <div
    :class="{ 'account-page__header': isMyAccountPage }"
    class="header items-center h-20"
  >
    <div
      v-if="!isMyAccountPage"
      class="w-full flex items-center rounded-xl sm:w-[293px]"
    >
      <Input
        class="border-none h-10 gap-3 bg-greyscale-185 dark:bg-dark-mode-100"
        v-model="q"
        @enter="searchText"
        :placeholder="getPlaceHolderByRouteName"
        type="text"
        search
      >
        <img class="w-4" src="@/assets/images/search.svg" alt="" />
        <img
          v-if="this.q"
          class="order-1 cursor-pointer"
          @click="clearDevices"
          src="@/assets/images/x.svg"
          alt=""
        />
      </Input>
    </div>
    <div class="header__profile flex items-center relative gap-2">
      <ContactUs />
      <HeaderUser />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Input from "@/components/Input";
import HeaderUser from "@/components/HeaderUser";
import ContactUs from "@/components/ContactUs";

export default {
  name: "Header",
  data() {
    return {
      q: "",
      pageFilter: {
        devices: "",
        apps: "",
      },
      empty: "",
      isMyAccountPage: false,
    };
  },
  props: {
    value: String,
  },
  components: {
    Input,
    HeaderUser,
    ContactUs,
  },
  mounted() {
    this.$root.$on("update-header-q", (q) => {
      if (q) {
        this.q = q;
        let routeObj = {
          name: this.routeName === "Home" ? "Devices" : this.routeName,
        };
        routeObj.query = { q: q };
        this.$router.push(routeObj).catch(() => {});
      }
    });
  },
  methods: {
    ...mapActions(["emitMixPanelEvent"]),
    route(path) {
      this.$router.push(path);
    },
    searchText(e) {
      const query = e;
      let routeObj = {
        name: this.routeName === "Home" ? "Devices" : this.routeName,
      };
      if (e) {
        routeObj.query = { q: e };
      }
      this.$router.push(routeObj).catch(() => {});
      sessionStorage.setItem("value", JSON.stringify(query));
    },
    clearDevices() {
      this.$emit("clear-filter", ["deviceName", "deviceBrand"]);
      this.searchText(this.empty);
      this.q = "";
    },
  },
  created() {
    this.q = this.$route.query.q || "";
    if (this.q) {
      this.searchText(this.q);
    }
    this.isMyAccountPage =
      this.$route.name === "MyProfile" ||
      this.$route.name === "ChangePassword" ||
      this.$route.name === "Pricing";
    this.$route.name === "Preferences";
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    getPlaceHolderByRouteName() {
      if (this.routeName === "ApplicationsPage") {
        return this.$t("input.applist.placeholder");
      }
      return this.$t("input.devicelist.placeholder");
    },
  },
  watch: {
    q(value) {
      this.$emit("input", value);
    },
    $route(to, from) {
      if (to.path !== from.path) {
        this.pageFilter[from.meta.preName] = this.q || "";
        this.q = this.pageFilter[to.meta.preName];
        this.searchText(this.q);
      }
    },
    "$route.name"(newValue) {
      this.isMyAccountPage =
        newValue === "MyProfile" ||
        newValue === "ChangePassword" ||
        newValue === "Pricing" ||
        newValue === "Preferences";
    },
  },
};
</script>
<style>
@import "index.module.css";
</style>
